import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import { NextArrow, PrevArrow } from './CustomeArrow';

function HomeBanner(){
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        autoplay:true,
        fade:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
      };
    return(
        <>
            <div className="home-slider">
                <Slider {...settings}>
                    <div className="slider-item">
                        <img src="images/slider_1.jpg" alt="Slide 1"  height={1000} width={1900} />
                        <div className="slider-txt">Your Global Partners in <strong>Trade and Logistics</strong></div>
                    </div>
                    <div className="slider-item">
                        <img src="images/slider_2.jpg" alt="Slide 2"  height={1000} width={1900} />
                        <div className="slider-txt">Reliable Logistics <strong>Anywhere, Anytime</strong></div>
                    </div>
                    <div className="slider-item">
                        <img src="images/slider_3.jpg" alt="Slide 3"  height={1000} width={1900} />
                        <div className="slider-txt">Creating Opportunities <strong>from Boundaries</strong></div>
                    </div>                    
                </Slider>
            </div>
        </>
    );
}

export default HomeBanner;